import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import { ILearningContent } from '@/modules/corporate/components/LearningContent/types';

import { renderExternalContentType, renderProviderImage } from './renderers';

function ExternalContentProvider({ content }: { content: ILearningContent }) {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" gapX={6}>
      {renderProviderImage(
        content?.provider?.name ?? 'provider image',
        content?.provider?.logo?.url,
      )}
      {renderExternalContentType(t, content.externalContentType)}
    </Stack>
  );
}

export default React.memo(ExternalContentProvider);
